import React from 'react'

export  function Error404() {
  return (
    <div>Error404</div>
  )
}
